import React from 'react';
import { Link } from 'react-router-dom';
import './HomeAllProductsSection.scss';

const HomeAllProductsSection = () => (
  <section className="home-section home-all-products" aria-labelledby="home-all-products-title">
    <div>
      <p className="home-eyebrow">Full catalog</p>
      <h2 id="home-all-products-title">Browse every piece</h2>
      <p>Rings, pendants, bracelets, materials and sizes in one view.</p>
    </div>
    <Link to="/products" className="home-all-products__link">
      View catalog
    </Link>
  </section>
);

export default HomeAllProductsSection;
